import { render } from "./OfficialAccount.vue?vue&type=template&id=014983cc&scoped=true&ts=true"
import script from "./OfficialAccount.vue?vue&type=script&lang=ts"
export * from "./OfficialAccount.vue?vue&type=script&lang=ts"

import "./OfficialAccount.vue?vue&type=style&index=0&id=014983cc&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014983cc"]])

export default __exports__